import { render, staticRenderFns } from "./11_main.vue?vue&type=template&id=70e6f646"
import script from "./11_main.vue?vue&type=script&lang=js"
export * from "./11_main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports